<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Crear / Editar -->
    <v-dialog max-width="65%" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_cancelacion_motivo === null ? "Crear" : "Editar" }} Motivo de Cancelación
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Eliminar -->
    <v-dialog max-width="65%" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Motivo de Cancelación</v-card-title>

        <v-card-text>
          ¿Está seguro de que desea eliminar el motivo de cancelación llamado
          "{{ editedItem.nombre }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón crear -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Crear Motivo de Cancelación
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="openDialogDelete(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,

    loading: false,
    loadingSave: false,
    loadingDelete: false,

    items: [],
    headers: [
      {
        text: "Motivo de cancelación",
        value: "nombre",
        align: "center",
        width: "90%"
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],

    editedItem: {
      id_cancelacion_motivo: null,
      nombre: ""
    },
    defaultEditedItem: {
      id_cancelacion_motivo: null,
      nombre: ""
    }
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.loading = true;
      axios
        .get("/Catalogos/ListarMotivosCancelacion")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al cargar los motivos de cancelación.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogAddEdit(editItem = null) {
      if (editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);

      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      if (
        this.editedItem.nombre == null ||
        this.editedItem.nombre.length === 0 ||
        this.editedItem.nombre.length > 256
      ) {
        this.$refs.alert.setMessage("", "Debe de ingresar un Nombre entre 1 y 256 caracteres");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      const isCreate = this.editedItem.id_cancelacion_motivo === null;

      axios({
        method: isCreate ? "POST" : "PUT",
        url: isCreate
          ? "/Catalogos/CrearMotivoCancelacion"
          : `/Catalogos/EditarMotivoCancelacion/${this.editedItem.id_cancelacion_motivo}`,
        data: {
          nombre: this.editedItem.nombre
        }
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((error) => {
          if (error?.response?.status === 409) {
            this.$refs.alert.setMessage("", "Ya existe un Motivo de Cancelación con el mismo Nombre.");
            this.$refs.alert.open();
            return;
          }

          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al guardar el motivo de cancelación.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      if (this.editedItem.id_cancelacion_motivo == null) return;

      this.loadingDelete = true;
      axios
        .delete(`/Catalogos/EliminarMotivoCancelacion/${this.editedItem.id_cancelacion_motivo}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
          this.$refs.alert.setMessage("", "Ocurrió un error al eliminar el motivo de cancelación.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
};
</script>
